import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/did";
import {
  postForgetPasswordFailure,
  postForgetPasswordSuccess,
} from "../slices/features/auth";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* fetchForgetPassword(action: any) {
  const { payload } = action;
  const { data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.postForgetPassword,
      baseUrl,
      data
    );

    yield put(postForgetPasswordSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postForgetPasswordFailure({ statusCode, statusText }));
  }
}

export function* watchForgetPassword() {
  yield takeLatest(RequestTypes.POST_FORGET_PASSWORD, fetchForgetPassword);
}
